<template>
  <a-modal
    title="分配岗位"
    :visible="visible"
    :footer="null"
    width="820px"
    @cancel="close"
  >
    <a-alert
      type="info"
      show-icon
      style="margin-bottom: 12px"
      :message="`当前权限模型下，菜单功能权限经 岗位→角色→权限 链路生效；下方可查看每个岗位分配的所有用户（老的按角色分配入口保留未废除）${menu.name ? '。当前菜单：' + menu.name : ''}`"
    />
    <a-table
      bordered
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :dataSource="positions"
      :pagination="false"
      :scroll="{ y: 380 }"
    >
      <template slot="levelCol" slot-scope="text">
        {{ text === 0 ? "公司级" : "部门级" }}
      </template>
      <template slot="statusCol" slot-scope="text">
        <a-badge :status="text === 'active' ? 'success' : 'error'" :text="text === 'active' ? '启用' : '停用'" />
      </template>
      <template slot="actionCol" slot-scope="text, record">
        <a @click="openUsers(record)">查看用户 / 添加用户</a>
      </template>
    </a-table>

    <!-- 复用岗位用户管理对话框：查看/添加/移除岗位用户 -->
    <position-user-modal :visible.sync="userModalVisible" :position="currentPosition" />
  </a-modal>
</template>

<script>
import { fetchPositionList } from "@/api/setting/auth";
import PositionUserModal from "@/views/setting/auth/components/position-user-modal";

export default {
  name: "menu-position-modal",

  components: { PositionUserModal },

  props: {
    visible: { type: Boolean, default: false },
    // 菜单对象
    menu: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      loading: false,
      positions: [],
      userModalVisible: false,
      currentPosition: {},
      columns: [
        { title: "岗位编码", dataIndex: "code", width: 150 },
        { title: "岗位名称", dataIndex: "name", width: 170 },
        { title: "级别", dataIndex: "level", width: 90, align: "center", scopedSlots: { customRender: "levelCol" } },
        { title: "所属部门", dataIndex: "deptName", width: 160 },
        { title: "状态", dataIndex: "status", width: 90, align: "center", scopedSlots: { customRender: "statusCol" } },
        { title: "操作", align: "center", scopedSlots: { customRender: "actionCol" } },
      ],
    };
  },

  watch: {
    visible(val) {
      if (val) {
        this.load();
      }
    },
  },

  methods: {
    load() {
      this.loading = true;
      fetchPositionList()
        .then((res) => {
          this.positions = Array.isArray(res) ? res : [];
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    openUsers(record) {
      this.currentPosition = record;
      this.userModalVisible = true;
    },
    close() {
      this.$emit("update:visible", false);
    },
  },
};
</script>
